import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import {
  GetAppointmentsByServiceDateRangeApiResponse,
  GetAppointmentsByServiceDateRangeParams,
  LatestNoteStatusAppointmentInput,
  SaveAppointmentsInput,
  SoftDeleteAppointmentInput,
  NoteStatusAppointmentInput,
} from './appointment-interface';

export const getAppointmentsByServiceDateRange = async ({
  date,
}: GetAppointmentsByServiceDateRangeParams): Promise<
  GetAppointmentsByServiceDateRangeApiResponse[]
> => {
  const data = await API.get(API_SERVICES.APPOINTMENT_API, `/appointments/${date}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const getAppointmentsByProviderGuidAndStartDate = async ({
  providerGuid,
  date,
}: GetAppointmentsByServiceDateRangeParams): Promise<
  GetAppointmentsByServiceDateRangeApiResponse[]
> => {
  const data = await API.get(
    API_SERVICES.APPOINTMENT_API,
    `/appointments/users/${providerGuid}/${date}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return data.data;
};

export const saveAppointments = async (data: SaveAppointmentsInput[]) => {
  const res = await API.post(API_SERVICES.APPOINTMENT_API, `/appointments`, {
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};

export const softDeleteAppointment = async (data: SoftDeleteAppointmentInput) => {
  const res = await API.patch(
    API_SERVICES.APPOINTMENT_API,
    `/go/appointments/${data.appointmentId}/notes/${data.noteId}`,
    {
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return res.data;
};

export const latestNoteStatusAppointment = async (data: LatestNoteStatusAppointmentInput) => {
  const res = await API.get(
    API_SERVICES.APPOINTMENT_API,
    `/go/appointments/${data.appointmentId}/notes/${data.noteId}/note-status/latest`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return res.data;
};

export const updateAppointmentProperties = async (data: NoteStatusAppointmentInput) => {
  const res = await API.patch(
    API_SERVICES.APPOINTMENT_API,
    `/go/appointments/${data.appointmentId}/notes/${data.noteId}`,
    {
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return res.data;
};
